export const getAllActivities = `
  query getAllActivities {
    activities {
      value: id
      label: displayName
    }
  }
`;

export interface AllActivitiesResponse {
  activities: {
    value: string;
    label: string;
  }[];
}
